import { useEffect } from '@wordpress/element';
import GenerateCss from '../functions/GenerateCss.jsx';
import useSyncCompiledCss from '../hooks/useSyncCompiledCss.jsx';

function Style( { attributes, clientId, setAttributes } ) {
	const { blockId } = attributes;
	const uniqueId = blockId;
	const unique = uniqueId
		? `.alpha-columns-blocks.alpha-columns-block-${ uniqueId }`
		: '.wp-block-alphablock-columns';
	const {
		containerBorder,
		containerBorderRadius = {},
		margin,
		padding,
		verticalAlignment,
		columnGap,
		containerBackground,
		flexDirection,
		justifyContent,
		flexWrap,
		minHeight,
	} = attributes;

	const CssObj = {
		[ unique ]: [
			GenerateCss.css( 'display', 'flex' ), // Add display flex
			GenerateCss.css( 'flex-direction', flexDirection ),
			GenerateCss.css( 'justify-content', justifyContent ),
			GenerateCss.css( 'flex-wrap', flexWrap ), // Allow columns to wrap
			GenerateCss.border( containerBorder ),
			GenerateCss.borderRadius( containerBorderRadius ),
			GenerateCss.margin( margin ),
			GenerateCss.padding( padding ),
			GenerateCss.css( 'align-items', verticalAlignment ),
			GenerateCss.css(
				'gap',
				columnGap?.desktop?.val + '' + columnGap?.desktop?.unit
			),
			GenerateCss.background( containerBackground ),
			GenerateCss.css(
				'min-height',
				minHeight?.desktop?.val + '' + minHeight?.desktop?.unit
			),
		],
	};

	const compiledCss = GenerateCss.CompiledCss( CssObj );

	useSyncCompiledCss( compiledCss, setAttributes );

	return <style>{ compiledCss }</style>;
}

export default Style;
